<template>
  <v-app id="app">
    <Home />
  </v-app>
</template>

<script>
import Home from "@/views/Home.vue";

export default {
  name: "App",
  components: { Home },
  created() {
    this.$store.dispatch("room/init");
    const usesDarkMode = parseInt(localStorage.getItem("pebbles-dark-mode"));
    this.$vuetify.theme.dark = usesDarkMode === 1;
    document.body.setAttribute("theme", this.$vuetify.theme.dark ? "dark" : "light");
  }
};
</script>

<style lang="scss">
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.35);
  display: grid;
  place-items: center;
  z-index: 100;
}
</style>
